import { useCssVars as _useCssVars, unref as _unref } from 'vue'
import {computed} from 'vue'


export default {
  __name: 'file-icon',
  props: {
  width: {
    type: String, default: '3.2rem'
  },
  height: {
    type: String, default: '4rem'
  },
  ext: {
    type: String, required: false, default: 'txt'
  },
  fontSize: {
    type: String, default: '1rem'
  },  
  error: {
    type: Boolean, default: false
  },
  pulse: {
    type: Boolean, default: false
  },
  painted: {
    type: Boolean, default: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "9c937dac-file_fill": (file_fill.value),
  "9c937dac-file_stroke": (file_stroke.value),
  "9c937dac-fontSize": (__props.fontSize),
  "9c937dac-label_color": (label_color.value)
}))

const props = __props

const ext_colors = {
  // documents
  pdf: 'error-600',
  doc: 'blue-dark-600',
  docx: 'blue-dark-600',
  xml: 'indigo-600',
  xls: 'green-600',
  ppt: 'orange-dark-600',
  pptx: 'orange-dark-600',
  csv: 'green-600',
  txt: 'gray-700',
  // images
  jpg: 'brand-600'
}

const label_color = computed(() => props.error ? 'var(--orange-dark-600)' : `var(--${ext_colors[props.ext] || 'gray-700'})`)
const file_stroke = computed(() => props.error ? 'var(--error-300)' : 'var(--gray-300)')
const file_fill = computed(() => props.error ? 'var(--error-100)' : 'var(--base-white)')

const __returned__ = { props, ext_colors, label_color, file_stroke, file_fill, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}